export enum ServiceWizardStep {
  SERVICE = 'service',
  FORWARD_ROUTE = 'forwardRoute',
  BACKWARDS_ROUTE = 'backwardsRoute',
  FORWARD_SETUP = 'forwardSetup',
  BACKWARDS_SETUP = 'backwardsSetup',
}
